export type IconSize = "sm" | "md" | "lg";

const ICON_SIZES: Record<IconSize, number> = {
  sm: 16,
  md: 20,
  lg: 24,
};

export function resolveIconSize(
  size: number | IconSize | undefined,
  defaultSize = 24,
): number {
  if (size === undefined) return defaultSize;
  if (typeof size === "number") return size;
  return ICON_SIZES[size];
}

export type IconProps = {
  /**
   * Icon size. Accepts a pixel value or a named size: "sm" (16), "md" (20), "lg" (24).
   * @default 24
   */
  size?: number | IconSize;
  /**
   * Icon color
   * @default "currentColor"
   */
  color?: string;
  /**
   * Additional class name
   */
  className?: string;
} & Omit<React.SVGProps<SVGSVGElement>, "color" | "className">;
